(() => {
  if (window.__kptHomeReady) return;
  window.__kptHomeReady = true;
  const config = document.querySelector('script[data-kpt-motion]');
  if (!config) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motion = config.dataset.kptMotion === 'true';
  const cleanups = new Map();
  const io = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    }
  }), { threshold: .08, rootMargin: '0px 0px 35px 0px' });
  function initialize(scope = document) {
    if (!document.body.classList.contains('kpt-home')) return;
    scope.querySelectorAll('.kwf-section').forEach(section => {
      if (section.dataset.kptInitialized) return;
      section.dataset.kptInitialized = 'true';
      const releases = [];
      const panel = section.querySelector('.kwf-wrap');
      if (panel && motion && !reduced.matches && !window.Shopify?.designMode && section.getBoundingClientRect().top > innerHeight) {
        panel.classList.add('kpt-reveal');
        io.observe(panel);
        releases.push(() => io.unobserve(panel));
      }
      const video = section.querySelector('.kwf-hero__video');
      if (video) {
        const videoIO = new IntersectionObserver(entries => entries.forEach(e => {
          if (e.isIntersecting && !document.hidden && motion && !reduced.matches) video.play().catch(() => {});
          else video.pause();
        }), { threshold: .15 });
        videoIO.observe(video);
        const visibility = () => {
          if (document.hidden || reduced.matches || !motion) video.pause();
          else if (video.getBoundingClientRect().bottom > 0 && video.getBoundingClientRect().top < innerHeight) video.play().catch(() => {});
        };
        if (reduced.matches || !motion) video.pause();
        document.addEventListener('visibilitychange', visibility);
        releases.push(() => { videoIO.disconnect(); document.removeEventListener('visibilitychange', visibility); video.pause(); });
      }
      if (config.dataset.kptReelsAuto === 'true' && !window.Shopify?.designMode) {
        section.querySelectorAll('.kwf-watch-sec [data-kwf-rail]').forEach(rail => {
          const controls = rail.closest('.shopify-section')?.querySelector('[data-km-sl]');
          if (controls && ['on', 'off'].includes(controls.dataset.autoplay)) return;
          let onscreen = false, hovered = false, held = false, lastInteraction = 0;
          const railIO = new IntersectionObserver(entries => { onscreen = entries[0].isIntersecting; }, { threshold: .25 });
          railIO.observe(rail);
          const wrap = rail.closest('[data-kwf-railwrap]');
          const listen = (element, event, fn) => { element.addEventListener(event, fn); releases.push(() => element.removeEventListener(event, fn)); };
          listen(wrap, 'mouseenter', () => { hovered = true; });
          listen(wrap, 'mouseleave', () => { hovered = false; });
          listen(wrap, 'pointerdown', () => { held = true; lastInteraction = Date.now(); });
          listen(window, 'pointerup', () => { held = false; });
          listen(wrap, 'click', () => { lastInteraction = Date.now(); });
          listen(rail, 'wheel', () => { lastInteraction = Date.now(); });
          const timer = setInterval(() => {
            if (!onscreen || document.hidden || reduced.matches || held || wrap.contains(document.activeElement) || (hovered && config.dataset.kptPause === 'true') || Date.now() - lastInteraction < 7000) return;
            const max = rail.scrollWidth - rail.clientWidth;
            if (max < 5) return;
            const item = rail.querySelector('.kwf-rail__item');
            const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap || 0) : rail.clientWidth;
            rail.scrollTo({ left: rail.scrollLeft >= max - 8 ? 0 : Math.min(max, rail.scrollLeft + step), behavior: 'smooth' });
          }, Math.max(3000, Number(config.dataset.kptInterval || 6) * 1000));
          releases.push(() => { clearInterval(timer); railIO.disconnect(); });
        });
      }
      cleanups.set(section, () => releases.forEach(fn => fn()));
    });
  }
  const revealAll = () => {
    if (reduced.matches) document.querySelectorAll('.kpt-reveal').forEach(el => { el.classList.add('is-visible'); io.unobserve(el); });
    document.querySelectorAll('.kwf-hero__video').forEach(video => { if (reduced.matches) video.pause(); });
  };
  reduced.addEventListener('change', revealAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentElement || document));
  document.addEventListener('shopify:section:unload', event => {
    cleanups.forEach((cleanup, section) => {
      if (section === event.target || event.target.contains(section)) { cleanup(); cleanups.delete(section); }
    });
  });
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.kpt-reveal').forEach(el => el.classList.add('is-visible')));
})();

